import React, { Component } from 'react'
import ContactForm from './../ContactForm/ContactForm'
import GetInvolvedTabs from './GetInvolvedTabs'
import { Element, scroller } from 'react-scroll'

const Tabs = {
  0: 'curriculum',
  1: 'workshop'
}

class GetInvolved extends Component {

  constructor(props) {
    super(props)

    this.handleHostingClick = this.handleHostingClick.bind(this)
    this.handleRoleActive = this.handleRoleActive.bind(this)
    this.handleTabActive = this.handleTabActive.bind(this)
    
    this.state = {
      activeRole: '',
      activeTabIndex: 0
    }
  }

  componentDidMount() {
    if (this.props.params.value === 'hosting') {
      setTimeout(() => {
        this.handleRoleActive('Hosting a Workshop')}, 300)
    }
  }

  handleHostingClick() {
    this.handleRoleActive('Hosting a Workshop')
  }

  handleRoleActive(title) {
    scroller.scrollTo('ContactForm', {
      duration: 1500,
      delay: 100,
      isDynamic: true,
      smooth: true,
      offset: -50
    })
    this.setState({activeRole: title})
  }

  handleTabActive(value) {
    const { history } = this.props.route

    this.setState({activeTabIndex: value})
    history.push(`/get-involved/${Tabs[value]}`)
  }

  render() {
    const { activeRole, activeTabIndex } = this.state
    return (
      <div>
        <div className="section-header">
          <h1 className="title">GET INVOLVED</h1>
          <p>We’re building a one-of-a-kind, open-source curriculum with virtual content and collaborative hardware building modules. Our team is diverse, building content that ties together neuroscience, robotics, anatomy, data visualization, system networking and philosophy. Join our team!</p>
          <br />
          <p>Please reach out with your relevant experience to volunteer@mindmakersproject.org with the subject line filled in as the volunteer opportunity you're interested in.</p>
          <br />
        </div>
        <hr className="hr-material"/>
        <div className="get-involved-content">
          <GetInvolvedTabs
            handleRoleChange={this.handleRoleActive}
            handleTabChange={this.handleTabActive}
            tabIndex={activeTabIndex}
          />
        </div>
        <div>
        <ContactForm
          activeRole={activeRole}
          scrollElement={<Element name="ContactForm"></Element>}
          formName="Contact"
        />
        </div>
      </div>
    )
  }
}

export default GetInvolved



// WEBPACK FOOTER //
// ./src/components/GetInvolved/GetInvolved.js